import React, { Component, Fragment } from "react";
import QuestionUI from "./QuestionUI";
import AnsContainerUI from "./AnsContainerUI";
import CenterElement from "../../activity/activityComponent/CenterElement";

class MCQActivity extends Component {
  render = () => {
    let { activity, quizViewer } = this.props;

    let { quizViwerModel } = quizViewer.state;

    return (
      <Fragment>
        {/* <QuestionUI activity={activity} quizViewer={this.props.quizViewer} /> */}
        <AnsContainerUI
          activity={activity}
          quizViewer={this.props.quizViewer}
          reviewMode={this.props.reviewMode}
        />

        {/* <button onClick={this.handeShowFeedback}>مراجعة</button> */}
      </Fragment>
    );
  };

  handeShowFeedback = (e) => {
    let { activity, quizViewer } = this.props;
    let { quizViwerModel } = quizViewer.state;
    quizViwerModel.reviewMode = true;
    quizViewer.setState({ quizViwerModel });
  };
}

export default MCQActivity;
